import {Select} from 'antd';
import {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {deburr} from 'lodash';

const normalizeString = (value) => deburr(value?.toLowerCase());

const filterOption = (input, option) => {
  const value = option.children;
  if(typeof value === 'string' )
    return normalizeString(option.children).includes(normalizeString(input));
};

const InSituMeasurePlaceSelector = ({places, onChange, selectedPlace}) => {
  const {t} = useTranslation('templates');
  const handleSelect = useCallback((value) => {
    onChange?.(places?.find(place => place?._id === value));
  }, [onChange, places]);

  return (<>
    <Select
      className='w-full custom-select'
      onChange={onChange}
      value={selectedPlace?._id}
      onSelect={handleSelect}
      showSearch
      filterOption={filterOption}
    >
      {
        places?.map(place => (
          <Select.Option
            key={place?._id}
            value={place?._id}
          >
            {place?.place || <span style={{color: '#C9C7C1'} }> {t('placeNumber', {number: place?.keyPos?.[0] + 1 || ''})} </span> }
          </Select.Option>
        ))
      }
    </Select>
  </>);
};

InSituMeasurePlaceSelector.propTypes = {
  places: PropTypes.array,
  onChange: PropTypes.func,
  selectedPlace: PropTypes.object
};

export default memo(InSituMeasurePlaceSelector);
